<template>
    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14.1665 4.83333L13.4437 14.9521C13.3814 15.8243 12.6557 16.5 11.7813 16.5H4.88504C4.01064 16.5 3.2849 15.8243 3.2226 14.9521L2.49984 4.83333M6.6665 8.16667V13.1667M9.99984 8.16667V13.1667M10.8332 4.83333V2.33333C10.8332 1.8731 10.4601 1.5 9.99984 1.5H6.6665C6.20627 1.5 5.83317 1.8731 5.83317 2.33333V4.83333M1.6665 4.83333H14.9998"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        />
    </svg>
</template>
